<ftr-page>
  <article class="supported-browsers">
    <div elevioArticle articleId="30"></div>
  </article>
</ftr-page>
